let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ewJlC")).then(() => parcelRequire('2kWm6'));